import AdminPanel from './AdminPanel';
import CustomerPanel from './CustomerPanel';

const NavigationSections = [
    ...AdminPanel,
    ...CustomerPanel
];

export default NavigationSections;
